import { render } from "./PaymentType.vue?vue&type=template&id=af1c474c"
import script from "./PaymentType.vue?vue&type=script&lang=js"
export * from "./PaymentType.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__